var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      attrs: {
        error: _vm.errors.has("salutation"),
        "error-label": _vm.errors.first("salutation")
      }
    },
    [
      _c("q-select", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate.disable",
            value: "included:mr,ms",
            expression: "'included:mr,ms'",
            modifiers: { disable: true }
          }
        ],
        attrs: {
          value: _vm.value,
          "data-vv-name": "salutation",
          name: "salutation",
          options: _vm.salutationOptions,
          "display-value": _vm.salutationDisplayValue
        },
        on: { input: _vm.handleUpdate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }